
import { Injectable, Inject, EventEmitter } from '@angular/core';
import { EventInteraction } from "../dynamic/event.interaction.service";

@Injectable()
export class AppPlatformService {
    applicationOffline$ = new EventEmitter<boolean>();
    applicationPaused$ = new EventEmitter<boolean>();
    applicationHidden$ = new EventEmitter<boolean>();

    private suspended: boolean;
    get isSuspended() {
        return this.suspended;
    }

    constructor(private eventInteractions: EventInteraction) {
        let self = this;
        if (typeof document != 'undefined'){
            document.addEventListener("pause", () => { console.log("app::suspending"); this.suspended = true; self.triggerAppStateChange("suspend", true) }, false);
            document.addEventListener("resume", () => { console.log("app::resuming"); this.suspended = false; self.triggerAppStateChange("suspend", false) }, false);
            // document.addEventListener('webkitvisibilitychange', () => { console.log("app::webkitvisibilitychange::"+document.hidden); self.applicationHidden$.emit(document.hidden); }, false);
            document.addEventListener('visibilitychange', () => { console.log("app::visibilitychange::" + document.hidden); self.triggerAppStateChange("hidden",  document.hidden) }, false);
    
            //network events
            //if (Offline) {
            window.addEventListener("offline", (e) => { console.log("app::offline"); self.triggerAppStateChange("offline",  true) });
            window.addEventListener("online", (e) => { console.log("app::online"); self.triggerAppStateChange("offline",  false)  });
        }

        // }
    }

    private triggerAppStateChange(state: string, value: boolean) {
        this.eventInteractions.next({ key: "appStateChanged", message: { state: state, value: value } });
    }
}


// WEBPACK FOOTER //
// ./src/angular-engine/engine/service/ui/app-platform.service.ts